"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _omit2 = _interopRequireDefault(require("lodash/omit"));
var _cccisdReactRouter = require("cccisd-react-router");
var _pencil = _interopRequireDefault(require("cccisd-icons/pencil7"));
var _play = _interopRequireDefault(require("cccisd-icons/play4"));
var _spinner = _interopRequireDefault(require("cccisd-icons/spinner11"));
var _medal = _interopRequireDefault(require("cccisd-icons/medal"));
var _book = _interopRequireDefault(require("cccisd-icons/book3"));
var _cccisdLoader = _interopRequireDefault(require("cccisd-loader"));
var _cccisdModal = _interopRequireDefault(require("cccisd-modal"));
var _cccisdWysiwyg = require("cccisd-wysiwyg");
var _style = _interopRequireDefault(require("./style.css"));
var _useCourseWrapperMediator = _interopRequireDefault(require("./useCourseWrapperMediator"));
var _useOverlayBgStyles = _interopRequireDefault(require("./useOverlayBgStyles"));
var _index = _interopRequireDefault(require("./Certificate/index.js"));
var _CourseDescription = _interopRequireDefault(require("./CourseDescription"));
var _index2 = _interopRequireDefault(require("./CurriculumTabs/index.js"));
var _DeploymentPlayer = _interopRequireDefault(require("../../../DeploymentPlayer"));
var _InvokeSubMediator = _interopRequireDefault(require("./InvokeSubMediator"));
var _RepeatedFinalTest = _interopRequireDefault(require("./RepeatedFinalTest"));
var _Resources = _interopRequireDefault(require("./Resources"));
var _Tab = _interopRequireDefault(require("./Tab"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var CourseWrapperMediator = function CourseWrapperMediator(props) {
  var history = (0, _cccisdReactRouter.useHistory)();
  var modalRef = (0, _react.useRef)();
  var mediatorProps = props.mediatorProps;
  var certificate = mediatorProps.certificate,
    course = mediatorProps.course,
    courseDescription = mediatorProps.courseDescription,
    finalTest = mediatorProps.finalTest,
    registration = mediatorProps.registration,
    courseEval = mediatorProps.courseEval,
    resources = mediatorProps.resources,
    setIsShowingLayoutBgColor = mediatorProps.setIsShowingLayoutBgColor,
    renderCourseInOverlay = mediatorProps.renderCourseInOverlay,
    modalHeaderImageUrl = mediatorProps.modalHeaderImageUrl,
    modalHeaderImageFileName = mediatorProps.modalHeaderImageFileName,
    currentLayout = mediatorProps.currentLayout,
    topHeader = mediatorProps.topHeader;
  var _useCourseWrapperMedi = (0, _useCourseWrapperMediator["default"])(_objectSpread(_objectSpread({}, props), {}, {
      originalFlowList: props.flowList
    })),
    availableTabs = _useCourseWrapperMedi.availableTabs,
    currentTabs = _useCourseWrapperMedi.currentTabs,
    currTab = _useCourseWrapperMedi.currTab,
    curriculumProps = _useCourseWrapperMedi.curriculumProps,
    flowList = _useCourseWrapperMedi.flowList,
    isCourseComplete = _useCourseWrapperMedi.isCourseComplete,
    isLoading = _useCourseWrapperMedi.isLoading,
    isRepeatedFinalTest = _useCourseWrapperMedi.isRepeatedFinalTest,
    isTabMediatorComplete = _useCourseWrapperMedi.isTabMediatorComplete,
    latestFinalTestData = _useCourseWrapperMedi.latestFinalTestData,
    mediatorTabData = _useCourseWrapperMedi.mediatorTabData,
    onClickTab = _useCourseWrapperMedi.onClickTab,
    onExternalRegistrationComplete = _useCourseWrapperMedi.onExternalRegistrationComplete,
    onFinalTestComplete = _useCourseWrapperMedi.onFinalTestComplete,
    onFlowCompleteLocal = _useCourseWrapperMedi.onFlowCompleteLocal,
    onFlowStartedLocal = _useCourseWrapperMedi.onFlowStartedLocal,
    relatedDeploymentId = _useCourseWrapperMedi.relatedDeploymentId,
    setFlowList = _useCourseWrapperMedi.setFlowList,
    showExternalRegistrationDeployment = _useCourseWrapperMedi.showExternalRegistrationDeployment;
  (0, _react.useEffect)(function () {
    if (!isLoading && modalRef && modalRef.current && currTab !== 'courseDescription') {
      modalRef.current.open();
    }
  }, [currTab, modalRef.current, isLoading]);
  var overlayBgStyles = (0, _useOverlayBgStyles["default"])(currentLayout, setIsShowingLayoutBgColor);
  var renderTabs = function renderTabs() {
    if (!availableTabs.filter(function (tabName) {
      return !['course', 'registration'].includes(tabName);
    }).length) {
      return null;
    }

    // for curriculum navigation, "course" tab is considered Home
    if (course.isCurriculum && course.curriculumTabStyle === 'side') {
      return /*#__PURE__*/_react["default"].createElement(_index2["default"], _extends({}, props, {
        currentTabs: currentTabs,
        currTab: currTab,
        curriculumProps: curriculumProps
      }));
    }
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: _style["default"].topBar
    }, /*#__PURE__*/_react["default"].createElement("div", {
      role: "navigation",
      className: 'btn-group btn-group-justified ' + _style["default"].tabs
    }, currentTabs.filter(function (tab) {
      return renderCourseInOverlay ? tab !== 'courseDescription' : tab;
    }).map(function (tabKey) {
      return /*#__PURE__*/_react["default"].createElement(_Tab["default"], {
        currTab: currTab,
        key: tabKey,
        mediatorProps: mediatorProps,
        onClickTab: onClickTab,
        tabKey: tabKey
      });
    })));
  };
  var subMediatorTabs = ['course', 'courseEval'];
  if (!isRepeatedFinalTest) {
    subMediatorTabs.push('finalTest');
  }
  if (!showExternalRegistrationDeployment) {
    subMediatorTabs.push('registration');
  }
  var isSubMediator = subMediatorTabs.includes(currTab);
  // whenever component mounts or changes, see if we should toggle background
  (0, _react.useEffect)(function () {
    if (setIsShowingLayoutBgColor) {
      setIsShowingLayoutBgColor(!renderCourseInOverlay && !!(isSubMediator || currTab === 'registration' && showExternalRegistrationDeployment));
    }
    setFlowList(flowList.map(function (f) {
      delete f.completedLocally;
      return f;
    }));
  }, [currTab]);
  var subMediatorSettings = _objectSpread({}, mediatorProps[currTab]);
  if (course.isCurriculum && currTab === 'course' && curriculumProps) {
    subMediatorSettings.navigationSettings = curriculumProps;
  }
  var buttons = function buttons() {
    var visibleButtons = [];
    if (currentTabs.includes('registration')) {
      visibleButtons.push(/*#__PURE__*/_react["default"].createElement("button", {
        key: "registration",
        type: "button",
        className: "btn btn-warning",
        onClick: function onClick() {
          history.push("".concat(props.basePath, "/registration"));
        }
      }, /*#__PURE__*/_react["default"].createElement(_pencil["default"], {
        spaceRight: true
      }), "Register"));
    }
    if (currentTabs.includes('course')) {
      visibleButtons.push(isCourseComplete ? /*#__PURE__*/_react["default"].createElement("button", {
        key: "course",
        type: "button",
        className: "btn btn-info",
        onClick: function onClick() {
          history.push("".concat(props.basePath, "/course"));
        }
      }, /*#__PURE__*/_react["default"].createElement(_spinner["default"], {
        spaceRight: true
      }), "Review Course") : /*#__PURE__*/_react["default"].createElement("button", {
        key: "course",
        type: "button",
        className: "btn btn-primary",
        onClick: function onClick() {
          history.push("".concat(props.basePath, "/course"));
        }
      }, /*#__PURE__*/_react["default"].createElement(_play["default"], {
        spaceRight: true
      }), flowList.some(function (fl) {
        return fl.isStarted;
      }) ? 'Continue' : 'Start'));
    }
    if (currentTabs.includes('finalTest')) {
      visibleButtons.push(/*#__PURE__*/_react["default"].createElement("button", {
        key: "finalTest",
        type: "button",
        className: "btn btn-success",
        onClick: function onClick() {
          history.push("".concat(props.basePath, "/finalTest"));
        }
      }, /*#__PURE__*/_react["default"].createElement(_play["default"], {
        spaceRight: true
      }), (finalTest === null || finalTest === void 0 ? void 0 : finalTest.tabName) || 'Assessment'));
    }
    if (currentTabs.includes('courseEval')) {
      visibleButtons.push(/*#__PURE__*/_react["default"].createElement("button", {
        key: "courseEval",
        type: "button",
        className: "btn btn-success",
        onClick: function onClick() {
          history.push("".concat(props.basePath, "/courseEval"));
        }
      }, /*#__PURE__*/_react["default"].createElement(_play["default"], {
        spaceRight: true
      }), (courseEval === null || courseEval === void 0 ? void 0 : courseEval.tabName) || 'Course Evaluation'));
    }
    if (currentTabs.includes('certificate')) {
      visibleButtons.push(/*#__PURE__*/_react["default"].createElement("button", {
        key: "certificate",
        type: "button",
        className: "btn btn-primary",
        onClick: function onClick() {
          history.push("".concat(props.basePath, "/certificate"));
        }
      }, /*#__PURE__*/_react["default"].createElement(_medal["default"], {
        spaceRight: true
      }), "Certificate"));
    }
    if (currentTabs.includes('resources')) {
      visibleButtons.push(/*#__PURE__*/_react["default"].createElement("button", {
        key: "resources",
        type: "button",
        className: "btn btn-info",
        onClick: function onClick() {
          history.push("".concat(props.basePath, "/resources"));
        }
      }, /*#__PURE__*/_react["default"].createElement(_book["default"], {
        spaceRight: true
      }), "Resources"));
    }
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: _style["default"].buttons
    }, visibleButtons);
  };
  if (isLoading) {
    return /*#__PURE__*/_react["default"].createElement(_cccisdLoader["default"], {
      loading: true
    });
  }
  if (renderCourseInOverlay) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: _style["default"].modalContent
    }, currTab === 'courseDescription' ? /*#__PURE__*/_react["default"].createElement(_CourseDescription["default"], {
      settings: courseDescription,
      buttons: buttons
    }) : /*#__PURE__*/_react["default"].createElement(_cccisdModal["default"], {
      size: "calc(100vw - 40px)",
      bodyStyle: isSubMediator || currTab === 'registration' && showExternalRegistrationDeployment ? overlayBgStyles.style || {} : {},
      ref: modalRef,
      modalClassName: _style["default"].courseWrapperInOverlayModal,
      afterClose: function afterClose() {
        return history.push("".concat(props.basePath, "/courseDescription"));
      },
      title: modalHeaderImageFileName ? /*#__PURE__*/_react["default"].createElement(_cccisdWysiwyg.Html, {
        content: "<img src=\"".concat(modalHeaderImageUrl, "\" alt=\"").concat(modalHeaderImageFileName, "\" height=\"36\" data-image=\"980\" />")
      }) : ''
    }, /*#__PURE__*/_react["default"].createElement("div", {
      "data-cccisd-survey-area": true,
      style: {
        maxWidth: '1200px',
        flexGrow: 1
      }
    }, isSubMediator && /*#__PURE__*/_react["default"].createElement(_InvokeSubMediator["default"], _extends({}, props, mediatorTabData[currTab], {
      key: currTab,
      flowList: flowList.filter(function (f) {
        return mediatorProps[currTab].options.includes(f.handle);
      }),
      onFlowComplete: onFlowCompleteLocal,
      onFlowStarted: onFlowStartedLocal,
      settings: subMediatorSettings
    })), currTab === 'registration' && showExternalRegistrationDeployment && /*#__PURE__*/_react["default"].createElement(_DeploymentPlayer["default"], _extends({}, props, {
      pawnHash: props.actingPawnHash,
      pawnId: props.actingPawnId,
      deploymentId: Number(registration.externalRegistrationDeploymentId),
      disableLayout: true,
      onComplete: onExternalRegistrationComplete
    })), currTab === 'finalTest' && isRepeatedFinalTest && /*#__PURE__*/_react["default"].createElement(_RepeatedFinalTest["default"], _extends({}, props, mediatorTabData[currTab], {
      latestFinalTestData: latestFinalTestData,
      onComplete: onFinalTestComplete,
      relatedDeploymentId: relatedDeploymentId,
      settings: finalTest
    })), currTab === 'certificate' && /*#__PURE__*/_react["default"].createElement(_index["default"], _extends({}, props, {
      deploymentId: flowList.length ? flowList[0].responseSet : '',
      hide: !isCourseComplete || !isTabMediatorComplete('finalTest') || !isTabMediatorComplete('courseEval'),
      latestFinalTestData: latestFinalTestData,
      settings: certificate
    })), currTab === 'resources' && /*#__PURE__*/_react["default"].createElement(_Resources["default"], {
      settings: resources,
      isCourseComplete: isCourseComplete
    }))));
  }
  return /*#__PURE__*/_react["default"].createElement("div", null, topHeader && /*#__PURE__*/_react["default"].createElement(_cccisdWysiwyg.Html, {
    content: topHeader
  }), renderTabs(), currTab === 'courseDescription' && /*#__PURE__*/_react["default"].createElement(_CourseDescription["default"], {
    settings: courseDescription
  }), isSubMediator && /*#__PURE__*/_react["default"].createElement(_InvokeSubMediator["default"], _extends({}, props, mediatorTabData[currTab], {
    key: currTab,
    flowList: flowList.filter(function (f) {
      return mediatorProps[currTab].options.includes(f.handle);
    }),
    onFlowComplete: onFlowCompleteLocal,
    onFlowStarted: onFlowStartedLocal,
    settings: subMediatorSettings
  })), currTab === 'registration' && showExternalRegistrationDeployment && /*#__PURE__*/_react["default"].createElement(_DeploymentPlayer["default"], _extends({}, (0, _omit2["default"])(props, ['flowList']), {
    pawnHash: props.actingPawnHash,
    pawnId: props.actingPawnId,
    deploymentId: Number(registration.externalRegistrationDeploymentId),
    disableLayout: true,
    onComplete: onExternalRegistrationComplete
  })), currTab === 'finalTest' && isRepeatedFinalTest && /*#__PURE__*/_react["default"].createElement(_RepeatedFinalTest["default"], _extends({}, props, mediatorTabData[currTab], {
    latestFinalTestData: latestFinalTestData,
    onComplete: onFinalTestComplete,
    relatedDeploymentId: relatedDeploymentId,
    settings: finalTest
  })), currTab === 'certificate' && /*#__PURE__*/_react["default"].createElement(_index["default"], _extends({}, props, {
    deploymentId: flowList.length ? flowList[0].responseSet : '',
    hide: !isCourseComplete || !isTabMediatorComplete('finalTest') || !isTabMediatorComplete('courseEval'),
    latestFinalTestData: latestFinalTestData,
    settings: certificate
  })), currTab === 'resources' && /*#__PURE__*/_react["default"].createElement(_Resources["default"], {
    settings: resources,
    isCourseComplete: isCourseComplete
  }));
};
CourseWrapperMediator.propTypes = {
  actingPawnHash: _propTypes["default"].string,
  actingPawnId: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
  basePath: _propTypes["default"].string,
  flowList: _propTypes["default"].array.isRequired,
  isPreviewMode: _propTypes["default"].bool,
  language: _propTypes["default"].string,
  mediatorProps: _propTypes["default"].object,
  onAssignmentComplete: _propTypes["default"].func,
  onComplete: _propTypes["default"].func,
  onFlowComplete: _propTypes["default"].func,
  onFlowStarted: _propTypes["default"].func,
  onModuleComplete: _propTypes["default"].func
};
var _default = exports["default"] = CourseWrapperMediator;